<template>
  <div id="app">
    <div>
        <vue-extend-layouts></vue-extend-layouts>

      <!-- modals -->
      <edit-task-modal></edit-task-modal>
      <create-task-modal></create-task-modal>
      <edit-project-modal></edit-project-modal>
      <create-project-modal></create-project-modal>
      <day-info-modal></day-info-modal>
      <create-section-modal></create-section-modal>
      <mobile-device-modal></mobile-device-modal>
      <onboarding-modal></onboarding-modal>

      <confirm-email-notification v-if="!$store.state.account.email_confirmed && $route.path !== '/auth'"></confirm-email-notification>
    </div>
  </div>
</template>

<script>
  import EditTaskModal from './modals/EditTaskModal';
  import CreateTaskModal from './modals/CreateTaskModal';
  import EditProjectModal from './modals/EditProjectModal';
  import CreateProjectModal from './modals/CreateProjectModal';
  import DayInfoModal from './modals/DayInfoModal';
  import CreateSectionModal from './modals/CreateSectionModal';
  import MobileDeviceModal from './modals/MobileDeviceModal';
  import OnboardingModal from './modals/OnboardingModal';

  import VueExtendLayouts from 'vue-extend-layout';

  import ConfirmEmailNotification from './components/elements/ConfirmEmailNotification';

  import { mapGetters } from 'vuex';
  import moment from 'moment';

  const DEMO = false;

  export default {
    name: 'App',
    data () {
      return {
        loaded: false,
      };
    },
    components: {
      EditTaskModal,
      CreateTaskModal,
      EditProjectModal,
      CreateProjectModal,
      DayInfoModal,
      CreateSectionModal,
      MobileDeviceModal,
      OnboardingModal,
      ConfirmEmailNotification,
      VueExtendLayouts,
    },
    computed: {
      ...mapGetters([
        'account',
        'company',
        'members',
        'task_options',
        'selected_account_id',
        'selected_project_id',
        'selected_task',
        'task_template',
        'projects',
        'duration_actual_logs',
      ]),
    },
    sockets: {
      connect: function () {
        if (localStorage.getItem('token')) {
          this.$socket.emit('server_create_connection', {
            token: localStorage.getItem('token'),
          });
        }
        if (this.account.status && this.account.status !== 'inactive') {
          this.$store.dispatch('fetchTasks');
        }
      },
      create_connection_successful: function () {
      },
      update_task: function (data) {
        this.$store.commit('updateTask', JSON.parse(data));
      },
      create_duration_actual_log: function (data) {
        const newActualDurtionLogs = this.duration_actual_logs;
        newActualDurtionLogs.push(JSON.parse(data));
        this.$store.commit('fetchDurationActualLogs', newActualDurtionLogs);
      },
      delete_duration_actual_log: function (data) {
        const newActualDurtionLogs = this.duration_actual_logs;
        const json = JSON.parse(data);
        const existingIndex = newActualDurtionLogs.findIndex(time => {
          return time._id === json._id;
        });
        if (existingIndex >= 0) {
          newActualDurtionLogs.splice(existingIndex, 1);
        }
        this.$store.commit('fetchDurationActualLogs', newActualDurtionLogs);
      },
      update_duration_actual_log: function (data) {
        const json = JSON.parse(data);
        const newActualDurtionLogs = this.duration_actual_logs;
        const existingIndex = newActualDurtionLogs.findIndex(time => {
          return time._id === json._id;
        });
        if (existingIndex >= 0) {
          newActualDurtionLogs.splice(existingIndex, 1);
        }
        newActualDurtionLogs.push(json);
        this.$store.commit('fetchDurationActualLogs', newActualDurtionLogs);
      },
      new_message: function (data) {
        this.$store.dispatch('chat/GET_MESSAGE', JSON.parse(data));
      },
      update_unread_count: function (data) {
        this.account.unread_count = data;
        this.$store.commit('fetchAccount', this.account);
      },
    },
    mounted: function () {
      if (DEMO) {
        localStorage.setItem('token', '2e361ebcb0c73380ced9928b602e4a463a6cad5125ce7652');
      }

      const oldProjectId = localStorage.getItem('selectedProjectId');

      if (oldProjectId) {
        this.$store.commit('setSelectedProjectId', oldProjectId === 'null' ? null : oldProjectId);
      }

      const self = this;
      if (localStorage.getItem('token')) {
        self.$api().get('/auth/validate_token', {
          params: {
            token: localStorage.getItem('token'),
          },
        })
          .then(async function (response) {
            if (response.data.ok) {
              if (['/process_flow/create/new', '/chat_dedicated', '/panel/dialog_builder', '/today'].indexOf(self.$route.path) >= 0) {
                return {};
              }
              await self.$store.dispatch('fetchAccount');
              await self.$store.dispatch('fetchMembers');
              await self.$store.dispatch('fetchTaskTemplate');
              await self.$store.dispatch('fetchCompany');
              await self.$store.dispatch('fetchProjects');
              await self.$store.dispatch('fetchEpicLinks');
              await self.$store.dispatch('fetchSections');
              await self.$store.dispatch('fetchDurationActualLogs');
              await self.$store.dispatch('chat/FETCH_MESSAGES');
              if (['/', '/calendar', '/tasks'].indexOf(self.$route.path) >= 0) {
                return {};
              }
              return {};
            } else {
              self.$noty.error('Error: ' + response.data.error);
              localStorage.removeItem('token');
              window.location.href = `/auth${document.location.search}`;
            }
          })
          .catch(function (error) {
            if (!error.response) {
              self.$noty.error('Network Error occurred: Please, try again later.');
            } else {
            }
            localStorage.removeItem('token');
            window.location.href = `/auth${document.location.search}`;
          });
      } else {
        if (window.location.pathname !== '/auth') {
          window.location.href = '/auth';
        }
        self.$api().post('/auth/create_token', {}, {
          params: {
            utm_source: self.$route.query.utm_source,
            utm_medium: self.$route.query.utm_medium,
            utm_campaign: self.$route.query.utm_campaign,
            utm_term: self.$route.query.utm_term,
            utm_content: self.$route.query.utm_content,
            ref: self.$route.query.ref,
            invite: self.$route.query.invite,
            i: self.$route.query.i,
          },
        })
          .then(function (response) {
            if (response.data.ok) {
              localStorage.setItem('token', response.data.payload.token);
              self.$store.dispatch('fetchAccount');
            } else {
              self.$noty.error('Error: ' + response.data.error);
            }
          })
          .catch(function (error) {
            if (!error.response) {
              self.$noty.error('Network Error occurred: Please, try again later.');
            } else {
              self.$noty.error('An Error occurred: ' + error.response.data.error);
            }
          });
      }
      this.loaded = true;
    },
    watch: {
      $route: function () {
        if (['/calendar'].indexOf(this.$route.path) === -1) {
          this.$store.commit('setInboxView', false);
        }
      },
      account: function (NewValue) {
        this.$i18n.locale = NewValue.lang;
        if (NewValue.lang === 'en') {
          moment.locale('en-ie');
        } else {
          moment.locale('ru');
        }
      },
    },
  };

</script>

<style>
  @import '~vuejs-noty/dist/vuejs-noty.css';
  @import "styles/css/theme.css";
  @import "styles/fonts/feather/feather.css";

  *:focus {
    outline: none;
  }

  body {
    height: 100%;

  }

  .section-base {
    transition: all 700ms;
    box-shadow:0 .2rem .35rem rgba(0,0,0,.075);
  }

  .text-blue {
    color: #2c7be5;
  }

  .section-base:hover {
    -webkit-box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    -moz-box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    -ms-box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    -o-box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
  }

  .dash-section {
    border: 1px dashed #D2DDEC;
    border-radius: 0.375rem;
  }

  .unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .hidden-text {
    opacity: 0.3
  }
  .hidden-text:hover {
    opacity: 1
  }

</style>
